import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Admission = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />

            <Sidebar
                isOpen={open}
                close={() => setOpen(false)}
            />

            {/* HERO */}
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>Admission</h1>
                    <Breadcrumb />
                </div>
            </div>

            {/* ADMISSION CONTENT */}
            <main className="container contact-page admission-page">

                {/* INTRO HEADER */}
                <section className="admission-intro">

                    <h2>Admission Process</h2>

                    <div className="admission-title-line"></div>

                    <span className="admission-eyebrow">
                        NAV JEEVAN MISSION SCHOOL ANANDNAGAR
                    </span><br/>
                    <span className="admission-eyebrow">
                        Sonauli Road, Anandnagar, Maharajganj
                    </span>

                    <p>
                        We welcome parents and students to Nav Jeevan Mission
                        School, Anandnagar, where we are committed to providing
                        quality education, strong values and opportunities for
                        the holistic development of every child.
                    </p>
                </section>

                {/* ADMISSION STEPS */}
                <section className="admission-steps">

                    {/* STEP 1 */}
                    <div className="admission-step">
                        <div className="admission-step-number">
                            01
                        </div>

                        <div className="admission-step-content">
                            <span className="admission-step-label">
                                STEP 01
                            </span>

                            <h3>Registration</h3>

                            <p>
                                Parents seeking admission are required to obtain
                                and duly complete the official Application Form
                                attached with the School Prospectus.
                            </p>

                            <div className="admission-highlight">
                                <strong>Registration Fee</strong>
                                <span>₹300/-</span>
                            </div>

                            <p>
                                A non-refundable registration fee of ₹300/- is
                                payable at the time of registration. Registration,
                                however, does not guarantee admission or
                                reservation of a seat.
                            </p>
                        </div>
                    </div>

                    {/* STEP 2 */}
                    <div className="admission-step">
                        <div className="admission-step-number">
                            02
                        </div>

                        <div className="admission-step-content">
                            <span className="admission-step-label">
                                STEP 02
                            </span>

                            <h3>Entrance Assessment</h3>

                            <p>
                                Where vacancies are available, admission is
                                offered on the basis of an entrance
                                assessment/examination.
                            </p>

                            <p>
                                Registered applicants will be informed about the
                                date and details of the assessment. The school
                                reserves the right to assess the child and
                                determine the class appropriate to the child's
                                level of learning.
                            </p>
                        </div>
                    </div>

                    {/* STEP 3 */}
                    <div className="admission-step">
                        <div className="admission-step-number">
                            03
                        </div>

                        <div className="admission-step-content">
                            <span className="admission-step-label">
                                STEP 03
                            </span>

                            <h3>Selection &amp; Admission Confirmation</h3>

                            <p>
                                After the assessment, selected candidates will
                                be informed by the school.
                            </p>

                            <p>
                                Selection alone does not constitute confirmation
                                of admission. Admission will be confirmed only
                                after the prescribed fees are paid within the
                                stipulated period and the payment is duly
                                acknowledged by the school.
                            </p>
                        </div>
                    </div>

                    {/* STEP 4 */}
                    <div className="admission-step">
                        <div className="admission-step-number">
                            04
                        </div>

                        <div className="admission-step-content">
                            <span className="admission-step-label">
                                STEP 04
                            </span>

                            <h3>Documents Required</h3>

                            <p>
                                Parents must submit the required documents before
                                the child joins the school, including:
                            </p>

                            <ul className="admission-document-list">
                                <li>
                                    <span>✓</span>
                                    Birth Certificate – certified copy
                                </li>

                                <li>
                                    <span>✓</span>
                                    Transfer Certificate (TC) from the previous
                                    school, wherever applicable
                                </li>

                                <li>
                                    <span>✓</span>
                                    Previous school's academic records /
                                    progress report, wherever applicable
                                </li>

                                <li>
                                    <span>✓</span>
                                    Other documents required at the time of
                                    admission
                                </li>
                            </ul>

                            <p>
                                For students joining from another school, the
                                Transfer Certificate must be properly completed
                                and countersigned by the appropriate education
                                authority, wherever required.
                            </p>
                        </div>
                    </div>

                    {/* STEP 5 */}
                    <div className="admission-step">
                        <div className="admission-step-number">
                            05
                        </div>

                        <div className="admission-step-content">
                            <span className="admission-step-label">
                                STEP 05
                            </span>

                            <h3>Verification of Date of Birth</h3>

                            <p>
                                The child's date of birth must be supported by an
                                authentic Birth Certificate.
                            </p>

                            <div className="admission-important">
                                <span className="admission-important-icon">
                                    !
                                </span>

                                <p>
                                    Once the date of birth is entered in the
                                    school's Admission Register, it will not be
                                    altered later. Parents are therefore
                                    requested to ensure that all details are
                                    accurate at the time of admission.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* STEP 6 */}
                    <div className="admission-step">
                        <div className="admission-step-number">
                            06
                        </div>

                        <div className="admission-step-content">
                            <span className="admission-step-label">
                                STEP 06
                            </span>

                            <h3>Withdrawal &amp; Transfer Certificate</h3>

                            <p>
                                If a student is withdrawn from the school, the
                                Transfer Certificate (TC) will be issued after
                                the required notice has been given and all
                                outstanding fees and dues have been cleared
                                according to school rules.
                            </p>
                        </div>
                    </div>

                    {/* STEP 7 */}
                    <div className="admission-step">
                        <div className="admission-step-number">
                            07
                        </div>

                        <div className="admission-step-content">
                            <span className="admission-step-label">
                                STEP 07
                            </span>

                            <h3>Important Admission Guidelines</h3>

                            <ul className="admission-guidelines">
                                <li>
                                    Admission is subject to availability of
                                    seats.
                                </li>

                                <li>
                                    Registration does not guarantee admission.
                                </li>

                                <li>
                                    The Principal reserves the right to accept
                                    or reject an application in accordance with
                                    school rules.
                                </li>

                                <li>
                                    Admission is granted based on the child's
                                    suitability and the availability of a seat.
                                </li>

                                <li>
                                    No recommendation or outside influence will
                                    be entertained in the admission process.
                                </li>

                                <li>
                                    Parents/guardians are requested to
                                    communicate directly with the Principal's
                                    Office regarding admission.
                                </li>

                                <li>
                                    All information and documents submitted by
                                    parents must be complete and genuine.
                                </li>
                            </ul>
                        </div>
                    </div>

                </section>

                {/* JOURNEY SECTION */}
                <section className="admission-journey">

                    <div className="journey-content">

                        <span className="admission-eyebrow">
                            OUR COMMITMENT
                        </span>

                        <h2>A Journey Towards Excellence</h2>

                        <div className="admission-title-line"></div>

                        <p>
                            At Nav Jeevan Mission School, Anandnagar, admission
                            is not merely about securing a seat — it is the
                            beginning of a meaningful educational journey.
                        </p>

                        <p>
                            We look forward to welcoming your child into a
                            nurturing environment where knowledge, character,
                            confidence, creativity and leadership are developed
                            together.
                        </p>

                        <div className="journey-school">
                            <strong>
                                NAV JEEVAN MISSION SCHOOL, ANANDNAGAR
                            </strong>

                            <span>
                                Quality Education • Strong Values • Bright Future
                            </span>
                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
};

export default Admission;